import constants from "common/constants";

import logo from "./media/AS-Snjoll.png";
import logoPost from "./media/AS-Snjoll.png";

import EN_TRANSLATION from "./messages/en";
import IS_TRANSLATION from "./messages/is";
import backgroundImage from "./media/background.jpg";
import { Locale } from "../../../i18n/locale-config";

// TODO: move all clinicIds to .env file
let clinicId;
if (process.env.REACT_APP_ENV === "development") {
  clinicId = 1198;
} else if (process.env.REACT_APP_ENV === "stage") {
  clinicId = 1204;
} else if (process.env.REACT_APP_ENV === "production") {
  clinicId = 1169;
}

export default {
  name: "as",
  image: logo,
  imagePost: logoPost,
  imageQA: logoPost,
  footerImage: null,
  secondaryBackground: {
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    gradientColors: ["rgba(255, 255, 255, 0.7)", "rgba(255, 255, 255, 0.6)"]
  },
  appBackground: {
    url: backgroundImage
  },
  baseClass: "brand-as",
  domains: [
    "http://localhost:4008",
    "https://dev-as.healo.app",
    "https://stg-as.healo.app",
    "https://as.healo.app"
  ],
  clinicCityEnabled: false,
  clinicId: clinicId,
  ssnEnabled: false,
  anonymousEnabled: true,
  registrationWithEmailEnabled: true,
  registrationWithPhoneEnabled: true,
  emailVerificationEnabled: false,
  additionalSpaceOnRegistrationForm: false,
  homeTitle: "root.title",
  homeDescription: "root.desc",
  supportedLanguages: [Locale.IS, Locale.EN],
  defaultLanguage: [
    {
      test: [".*"],
      language: constants.appLanguages.is
    }
  ],
  translation: {
    [constants.appLanguages.is]: IS_TRANSLATION,
    [constants.appLanguages.en]: EN_TRANSLATION
  }
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/as/settings.js